import * as React from "react";

import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { ImageField, ImageInput } from "react-admin";

import GeneralSelect from "../components/GeneralSelect";
import LayoutContainer from "../components/LayoutContainer";
import LeftGridCreate from "../components/LeftGridCreate";
import PermissionChecker from "../../../components/PermissionChecker";
import RightGridCreate from "../components/RightGridCreate";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import StatusInput from "../components/StatusInput";
import TextInputRA from "../components/TextInputRA";
import TierBenefitFixedField from "../components/TierBenefitFixedField";
import TierConditionFixedField from "../components/TierConditionFixedField";
import TierValidation from "../../../ValidationRules/TierValidationRule";

const transform = (data) => ({
  ...data,
  level: Number(data.level),
  conditions: [
    { value: data.tier_condition_value, condition_id: data.tier_condition_id },
  ],
  privileges: [
    {
      condition: {
        value: data.condition_value,
        condition_id: data.condition_id,
      },
      item: { value: data.coupon_value, coupon_id: data.coupon_id },
    },
  ],
});
const useStyles = makeStyles((theme) => ({
  row: {
    display: "grid",
    gridTemplateColumns: "300px auto",
    gridGap: 5,
    width: "100%",
    alignItems: "center",
  },
}));

const TierCreate = (props) => {
  const classes = useStyles();
  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridCreate
          {...props}
          transform={transform}
          validate={TierValidation}
        >
          <SfBreadcrumbs path="Management/Tiers/New Tier" />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Tier name" source="name" />
            <TextInputRA required label="Level" source="level" type="number" />
            <TierConditionFixedField />

            <TextInputRA
              required
              label="Money Required"
              source="tier_condition_value"
              type="number"
            />
            <TierBenefitFixedField />
            <Box className={classes.row}>
              <GeneralSelect
                label="Benefit"
                source="coupon_id"
                resource="coupons"
                isDouble
                require
                tierFilter={false}
              />

              <TextInputRA
                required
                isDouble
                label=""
                source="coupon_value"
                type="number"
                noLabel
              />
            </Box>
            <Typography> Pictures</Typography>
            <ImageInput
              classes={{
                root: { backgroundColor: "blue" },
                dropZone: { border: "4px dotted blue", backgroundColor: "red" },
              }}
              label=""
              accept="image/*"
              source="image"
            >
              <ImageField
                source="src"
                title="title"
                style={{ dropZone: { marginLeft: 50 } }}
              />
            </ImageInput>
            <StatusInput />
          </Box>
        </LeftGridCreate>
        <RightGridCreate />
      </Grid>
      {/* <Create {...props} title="Create Tier" transform={transform}>
        <SimpleForm>
          <TextInputRA label="Tier name" source="name" />
          <TextInputRA label="Level" source="level" type="number" />
          <TierConditionFixedField />

          <TextInputRA
            label="Money Required"
            source="tier_condition_value"
            type="number"
          />
          <TierBenefitFixedField />
          <Box className={classes.row}>
            <ReferenceArrayInput
              label="Tier benefit"
              source="coupon_id"
              reference="coupons"
            >
              <SelectInputRA optionText="name" />
            </ReferenceArrayInput>
            <TextInputRA label="" source="coupon_value" type="number" noLabel />
          </Box>
          <ImageInput label="Icon" accept="image/*" source="image">
            <ImageField source="src" title="title" />
          </ImageInput>
          <StatusInput />
        </SimpleForm>
      </Create> */}
      <PermissionChecker code="Page.Merchant.Management.Tier" write />
    </LayoutContainer>
  );
};

export default TierCreate;
